import Revelar from '../components/Revelar'
import { cuidados } from '../data/contenido'

function Cuidados() {
  return (
    <section
      id="cuidados"
      aria-labelledby="titulo-cuidados"
      className="seccion-y border-t border-oro-profundo/20"
    >
      <div className="contenedor">
        <Revelar className="max-w-2xl">
          <p className="text-[0.7rem] uppercase tracking-[0.3em] text-oro sm:text-xs sm:tracking-[0.35em]">
            Guía
          </p>
          <h2 id="titulo-cuidados" className="mt-4 text-seccion font-light">
            {cuidados.titulo}
          </h2>
          <p className="mt-4 text-entradilla text-marfil-suave/80">
            {cuidados.entradilla}
          </p>
        </Revelar>

        <ol className="mt-10 space-y-px overflow-hidden rounded-sm bg-oro-profundo/25 sm:mt-14">
          {cuidados.articulos.map((articulo, i) => (
            <li key={articulo.titulo} className="bg-noche">
              <Revelar
                retraso={0.06 * i}
                // En móvil el número va sobre el título en una sola columna;
                // el gap baja a 0.5rem para que se lea como una unidad y no
                // como dos bloques sueltos.
                className="grid gap-2 p-5 sm:grid-cols-[auto_1fr] sm:gap-8 sm:p-8"
              >
                <span
                  className="font-display text-2xl leading-none text-oro-profundo sm:text-3xl"
                  aria-hidden="true"
                >
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div>
                  <h3 className="font-display text-lg text-marfil sm:text-xl">
                    {articulo.titulo}
                  </h3>
                  <p className="mt-3 max-w-2xl text-base leading-relaxed text-marfil-suave/80">
                    {articulo.texto}
                  </p>
                </div>
              </Revelar>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}

export default Cuidados
